function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M4 0C1.79086 0 0 1.79086 0 4V7.17436V7.97154V48.0001C0 52.4183 3.58173 56.0001 8.00001 56.0001H54.7941C59.2124 56.0001 62.7941 52.4183 62.7941 48.0001V15.1744C62.7941 10.7561 59.2124 7.17436 54.7941 7.17436H30.7691L25.1176 0H4Z",
  fill: "#8A93A6",
  fillOpacity: 0.5
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M16.8639 20.8786C17.8188 17.4063 20.9762 15 24.5775 15H60.1285C65.2135 15 69.0081 19.682 67.9551 24.6567L62.6631 49.6566C61.8803 53.3544 58.6163 55.9999 54.8365 55.9999H7.20508L16.8639 20.8786Z",
  fill: "#E5E6EA"
});

var SvgOpenFolder = function SvgOpenFolder(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 56,
    viewBox: "0 0 70 56",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgOpenFolder, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/open-folder.c8a19411.svg";
export { ForwardRef as ReactComponent };